import React from 'react';
import { Card as ChakraUICard, StackDirection, CardProps as ChakraCardProps } from '@chakra-ui/react';

export interface CardProps extends ChakraCardProps {
  variant?: 'elevated' | 'outline' | 'filled' | 'unstyled';
  size?: 'sm' | 'md' | 'lg';
  stackDirection?: StackDirection;
  dataAction?: string;
  dataObjectType?: string;
}

export const Card: React.FC<CardProps> = ({
  variant,
  size,
  stackDirection = 'column',
  dataAction,
  dataObjectType = 'core-card',
  children,
  ...rest
}) => {
  /**
   * DOM
   */
  return (
    <ChakraUICard
      variant={variant}
      size={size}
      data-object-type={dataObjectType}
      data-attribute={variant}
      data-action={dataAction}
      direction={stackDirection}
      {...rest}
    >
      {children}
    </ChakraUICard>
  );
};
